<div class="login-bg">
  <div class="modal-header">
    <h4 class="modal-title">{{'userManagement.Nodal Details' | translate}}</h4>
    <button type="button" class="close"  aria-label="Close">
      <span aria-hidden="true" (click)="closeModal()">&times;</span>
    </button>
  </div>
  
  <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="">{{'userManagement.Name of the Officer' | translate}}&nbsp; <span class="text-star">*</span></label>
                  <input type="text" [(ngModel)] = "userData['name']" onkeydown="return /[a-z, ]/i.test(event.key)"
                   minlength=2 maxlength=35 name="officername" class="form-control custom-selectbox"
                    placeholder="{{'userManagement.Enter Officer Name'|translate}}">
                  <span style="color:red" [hidden]="validation['name']">{{'userManagement.Please Enter Name' | translate}}</span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label class="">{{'userManagement.Email ID of Nodal Officer' | translate}} &nbsp; <span><i class="fas fa-info-circle"></i></span> &nbsp; <span class="text-star">*</span></label>
                  <input id="email_" type="text"   name="emailid"  [(ngModel)] = "userData['email']" 
                  (change)= "validateEmail(userData['email'])"  class="form-control custom-selectbox"
                   placeholder="{{'userManagement.Enter EmailID' | translate}}">
                  <span  style="color:red" [hidden]="validation['email']">{{'userManagement.Please Enter EmailID' | translate}}</span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label class="">{{'userManagement.Contact No of Nodal Officer' | translate}}  &nbsp; &nbsp; <span >({{'userManagement.optional'|translate}})</span></label>
                  <input type="text" (keypress)="keyPress($event)" minlength=10 maxlength=11 
                  title="Please enter exactly 10 digits"   name="contactnumber"  [(ngModel)] = "userData['mobilenum']"
                    class="form-control custom-selectbox" placeholder="{{'userManagement.Enter Contact Number' | translate}}">
                  <span style="color:red" [hidden]="validation['mobilenum']">{{'userManagement.Please Enter contact Number' | translate}}</span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label class="">{{'trigManage.selectdistrict' | translate}} &nbsp; <span><i class="fas fa-info-circle"></i></span> &nbsp; <span
                    class="text-star">*</span></label>
                <input type="text" name="contactnumber" disabled ="" [(ngModel)]="userData['districtname']" 
                class="form-control custom-selectbox" placeholder="{{'districtsdata.' +districtEntityName['entityName'] | translate}}">
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group text-center mb-0">
                <button class="btn btn-info pointer" (click)="profileFormSubmit()" type="submit">{{'header.submit' | translate}}</button>
              </div>
            </div>
          </div>
  </div>
  </div>
  